import sliceCreator from '../../index.jsx';
import {GET_ALL_MANDALS} from '../../../constants/index.jsx';
const _getAllMandalsAction = sliceCreator('GET_ALL_MANDALS', GET_ALL_MANDALS, 'get');

const { asyncAction: getAllMandalsAction, reducer, clearData: clearGetAllMandalsAction } = _getAllMandalsAction;

export default reducer;

export {
    getAllMandalsAction,
    clearGetAllMandalsAction
}